import type { IconData } from '@stacksjs/iconify-core'

export const thermometer: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M30.993 25.509A10.98 10.98 0 0 1 34.999 34c0 6.075-4.924 11-11 11s-11-4.925-11-11c0-3.419 1.56-6.474 4.007-8.491Q17 24.309 17 23c0-6.05.11-10.298.243-13.222c.17-3.74 2.44-6.714 6.183-6.774a36 36 0 0 1 1.147 0c3.743.06 6.013 3.034 6.183 6.774C30.89 12.702 31 16.95 31 23q0 1.31-.007 2.509\"/><path d=\"M20 34a4 4 0 1 0 8 0a4 4 0 1 0-8 0m4-24v20\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default thermometer
